import {ExternalAnalysisType} from "../../../../hospitals/edit-hospital/hospital.details";
import {GeneratorSentence, SentenceGroup, SentenceGroupsByAnalysisType} from "./generator-sentences.component";

export function ungroupSentenceGroups(groups: SentenceGroupsByAnalysisType): GeneratorSentence[] {
  return [
    ...ungroupForAnalysisType(groups.cas, "CAS"),
    ...ungroupForAnalysisType(groups.cardiologs, "CARDIOLOGS"),
  ];
}

function ungroupForAnalysisType(
  groups: SentenceGroup[],
  externalAnalysisType: ExternalAnalysisType
): GeneratorSentence[] {
  return groups.flatMap(group =>
    Object.entries(group.sentencesByLanguage).map(([language, sentence]) => ({
      key: group.key,
      sentence,
      language,
      externalAnalysisType
    }))
  );
}
